import $ from 'jquery';

var UploadWidget = (function () {
  var init = function () {
    $('.js__remove_image_btn').on('click', function () {
      var $parent = $(this).parents('.js__image-upload-container');

      $parent.find('.js__img-preview').hide().prop('src', false);
      $parent.find('.js__file-upload').hide();
      $parent.find('.js__img-upload').hide().prop('disabled', true);
      $parent.find('input[type="text"]').val('').hide().prop('disabled', true);
      $parent.find('input[type="file"]').prop('disabled', true);
      $parent.find('input[type="hidden"]').prop('disabled', true);

      if ($parent.next().is('input[type="hidden"]')) {
        $parent.next().val(true);
      }

      $(this).hide();
      $parent.find('.js__add_image_btn').show();
    });

    $('.js__add_image_btn').on('click', function () {
      var $parent = $(this).parents('.js__image-upload-container');

      $parent.find('input[type="text"]').prop('disabled', false).show();
      $parent.find('.js__img-upload').prop('disabled', false);
      $parent.find('input[type="file"]').prop('disabled', true);
      $parent.find('.js__file-upload').show().fileUpload();
      $(this).remove();
    });

    $('.js__file-delete-btn').on('click', function (e) {
      e.preventDefault();

      $('.js__item-del').transition('scale', function () {
        $(this).remove();
        $('.js__file-delete-btn').remove();
      });
      $(this).parents().next().val('true');
    });

    $('.js__image-upload-container')
      .find('input[type="file"]')
      .on('change', e => {
        const $imgPreview = $(e.currentTarget).parents('.js__image-upload-container').find('.js__img-preview');

        if (e.target.files) {
          const reader = new FileReader();

          reader.onload = () => {
            $imgPreview.attr('src', reader.result).show();
          };

          reader.readAsDataURL(e.target.files[0]);
        } else {
          $imgPreview.hide().prop('src', false);
        }

        $(e.currentTarget).parent().find('input[type="hidden"]').prop('disabled', false);
      });
  };

  return {
    init: init,
  };
})();

export default UploadWidget;
